












import { Vue, Component, Prop } from 'vue-property-decorator';

@Component
export default class Counter extends Vue {
  @Prop({ required: true }) incr!: Function;

  @Prop({ required: true }) decr!: Function;

  @Prop({ default: 1 }) delta!: number;

  @Prop({ default: 0 }) readonly currentCount!: number;
}
